module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/assessment_achievements/2_cc313146a8ef37c249aaa3ae30ec9836.jpg";